import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { AttendanceMonthlyPersonTableFilterSchema } from "../-zod-schema";

export const Route = createFileRoute(
  "/_staff/time-and-attendance/_layout/_list/summary/monthly-person/",
)({
  validateSearch: zodValidator(AttendanceMonthlyPersonTableFilterSchema),
});
